// Generated by ReScript, PLEASE EDIT WITH CARE


var recaptchaReloadTimeout = 3000;

export {
  recaptchaReloadTimeout ,
}
/* No side effect */
